import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, Loader2, Mail } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import api, { apiError } from "../lib/api";

export const BlogNewsletter = () => {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [website, setWebsite] = useState("");
  const submit = async (event) => {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setError("");
    try {
      const response = await api.post("/blog-updates/subscribe", { email, consent, website });
      setMessage(response.data.message);
    } catch (e) { setError(apiError(e)); }
    finally { setBusy(false); }
  };
  return (
    <section className="mt-14 border-y border-[#D4AF37]/50 py-10 grid md:grid-cols-2 gap-8 items-center" data-testid="blog-newsletter-section" aria-labelledby="blog-newsletter-title">
      <div className="min-w-0">
        <Mail size={25} className="text-emerald-700 mb-4" aria-hidden="true" />
        <h2 id="blog-newsletter-title" data-testid="blog-newsletter-title" className="font-display text-lg font-bold">Fresh ideas. Straight to your inbox.</h2>
        <p className="mt-2 text-sm text-slate-600" data-testid="blog-newsletter-description">Get the latest XpressPrompts blogs when they're published.</p>
      </div>
      {message ? (
        <div role="status" data-testid="blog-newsletter-success" className="text-sm text-emerald-800 flex items-start gap-3">
          <CheckCircle2 size={22} className="shrink-0" /> <p>{message}</p>
        </div>
      ) : (
        <form onSubmit={submit} className="min-w-0 space-y-3" data-testid="blog-newsletter-form">
          <label htmlFor="blog-newsletter-email" className="block text-sm font-semibold">Email address</label>
          <div className="flex flex-col sm:flex-row gap-2">
            <Input id="blog-newsletter-email" data-testid="blog-newsletter-email" type="email" autoComplete="email" maxLength={254} required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="min-w-0 bg-white" disabled={busy} />
            <Button type="submit" data-testid="blog-newsletter-submit" disabled={busy} className="shrink-0 bg-[#0B0F0D] text-[#D4AF37] hover:bg-emerald-950 gap-2">
              {busy ? <Loader2 size={16} className="animate-spin" /> : <ArrowRight size={16} />} {busy ? "Sending…" : "Get blog updates"}
            </Button>
          </div>
          <label className="flex items-start gap-2 text-xs text-slate-600 leading-relaxed">
            <input data-testid="blog-newsletter-consent" type="checkbox" required checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 shrink-0 accent-emerald-700" disabled={busy} />
            <span>I agree to receive blog updates by email. Unsubscribe anytime. <Link to="/privacy" data-testid="blog-newsletter-privacy" className="underline text-emerald-800">Privacy policy</Link></span>
          </label>
          <div hidden aria-hidden="true"><label>Website<input data-testid="blog-newsletter-website" tabIndex={-1} autoComplete="off" value={website} onChange={(e) => setWebsite(e.target.value)} /></label></div>
          {error && <p role="alert" data-testid="blog-newsletter-error" className="text-sm text-red-700">{error}</p>}
        </form>
      )}
    </section>
  );
};